<template>
    <section class="dish-restaurant__settings">
        <h2 class="dish-restaurant__settings-heading sr-only">Настройки отчета "Блюда"</h2>
        <form class="dish-restaurant__form" @submit.prevent>
            <fieldset class="dish-restaurant__fieldset dish-restaurant__fieldset_dateranges">
                <daterange-picker class="dish-restaurant__daterange"
                    v-model="reportDaterangeModel"
                    name="reportDaterange"
                >
                    Период отчета:
                </daterange-picker>
                <daterange-picker class="dish-restaurant__daterange"
                    v-if="modeId === 'compareOtherPeriod'"
                    v-model="compareDaterangeModel"
                    name="compareOtherPeriod"
                >
                    Период сравнения:
                </daterange-picker>
            </fieldset>
            <fieldset class="dish-restaurant__fieldset dish-restaurant__fieldset_toggles">
                <toggle-button class="dish-restaurant__toggle-input"
                    :color="toggleColors"
                    v-model="modeModel"
                    :width="130"
                    :labels="modeToggleLabels"
                />
                <toggle-button class="dish-restaurant__toggle-input"
                    :color="toggleColors"
                    v-model="itemsModel"
                    :width="100"
                    :labels="itemsToggleLables"
                />
            </fieldset>
        </form>
    </section>
</template>

<script>
    import { mapMutations, mapState } from "vuex";
    import DaterangePicker from "@/components/DaterangePicker";

    export default {
        name: "DishTotalSettings",
        components: {
            DaterangePicker,
        },
        computed: {
            ...mapState({
                reportDaterange: state => state.report.daterange,
                compareDaterange: state => state.dish.compareDaterange,
                itemsId: state => state.dish.itemsId,
                modeId: state => state.dish.modeId,
            }),
            reportDaterangeModel: {
                get() {
                    return this.reportDaterange;
                },
                set(daterange) {
                    this.setReportDaterange(daterange);
                }
            },
            compareDaterangeModel: {
                get() {
                    return this.compareDaterange;
                },
                set(value) {
                    this.setDishParameter({ parameter: "compareDaterange", value });
                }
            },
            modeModel: {
                get() {
                    return this.modeId === "compareOtherPeriod";
                },
                set(isCompareOtherPeriod) {
                    this.setDishParameter({
                        parameter: "modeId",
                        value: isCompareOtherPeriod ? "compareOtherPeriod" : "base"
                    });
                }
            },
            modeToggleLabels() {
                return {
                    unchecked: "Данные периода",
                    checked: "Сравнение периодов"
                };
            },
            itemsModel: {
                get() {
                    return this.itemsId === "dishes";
                },
                set(isDishes) {
                    this.setDishParameter({
                        parameter: "itemsId",
                        value: isDishes ? "dishes" : "groups"
                    });
                }
            },
            itemsToggleLables() {
                return {
                    unchecked: "Группы блюд",
                    checked: "Блюда"
                };
            },
            toggleColors() {
                return {
                    unchecked: "#e64d53",
                    checked: "#e0121a"
                };
            },
        },
        methods: {
            ...mapMutations([
                "setReportDaterange",
                "setDishParameter",
            ]),
        }
    };
</script>

<style lang="scss">
    .dish-restaurant__settings {
        margin-bottom: 15px;
    }
    .dish-restaurant__fieldset {
        display: grid;
        grid-auto-columns: auto;
        grid-auto-rows: auto;
        grid-gap: 10px;
        justify-content: start;
        align-content: start;
        justify-items: start;
        align-items: start;

        @include desktop {
            grid-auto-flow: column;
        }

        &_dateranges {
            margin-bottom: 15px;
        }
    }
</style>
